import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, AlertController, ToastController } from 'ionic-angular';
import { AngularFireAuth } from 'angularfire2/auth';
import { FormBuilder, Validators } from '@angular/forms';
import { PasswordRecoveryPage } from "../password-recovery/password-recovery";
import { Globals } from '../../../globals';
import { App } from 'ionic-angular'
import { MyApp } from '../../../app/app.component';
import { TranslateService } from '@ngx-translate/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { AuthServices } from '../services';

/**
 * Generated class for the LoginPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {
  public loginForm: any;

  constructor(public afAuth: AngularFireAuth,
    public fb: FormBuilder,
    public navCtrl: NavController,
    public navParams: NavParams,
    public alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    private toastCtrl: ToastController,
    public globals: Globals,
    public appCtrl: App,
    public translate: TranslateService,
    public afs: AngularFirestore,
    public authService: AuthServices) {
    let EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
    this.loginForm = fb.group({
      email: ['', Validators.compose([Validators.required, Validators.pattern(EMAIL_REGEXP)])],
      password: ['', Validators.compose([Validators.minLength(6), Validators.required])]
    });
  }

  login() {
    if (!this.loginForm.valid) {
      //devolver toast en funcion del error en el login
      if (this.loginForm.value.email == '' || this.loginForm.value.password == '') {
        this.launchToastCtrl(this.translate.instant('instant-sin-email-password'));
      } else if (!this.loginForm.controls.email.valid) {
        this.launchToastCtrl(this.translate.instant('instant-formato-email-no-valido'));
      } else if (!this.loginForm.controls.password.valid) {
        this.launchToastCtrl(this.translate.instant('instant-contrasena-no-valida'));
      }
    } else {
      let loadingPopup = this.loadingCtrl.create({
        spinner: 'crescent',
        content: this.translate.instant('instant-iniciando-sesion')
      });
      loadingPopup.present();

      this.afAuth.auth.signInWithEmailAndPassword(this.loginForm.value.email, this.loginForm.value.password)
        .then(async authData => {
          window.location.reload();
          this.appCtrl.getRootNav().setRoot(MyApp);
          loadingPopup.dismiss();
        }, error => {
          var errorMessage: string = error.message;
          let alert = this.alertCtrl.create({
            title: this.translate.instant('instant-login-incorrecto'),
            message: errorMessage,
          });
          loadingPopup.dismiss().then(() => {
            alert.present();
          });
        });
    }

  }

  openPasswordRecovery() {
    this.navCtrl.push(PasswordRecoveryPage)
  }

  launchToastCtrl(msg) {
    let toast = this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    });
    toast.present();
  }

  openRegister() {
    //this.navCtrl.setRoot(RegisterPage);
    this.authService.page_show = 'register';
  }


}



// WEBPACK FOOTER //
// ./src/pages/auth/login/login.ts